import { useLayoutEffect, useRef } from 'react';

export function useLatestHandlers<Handlers extends Record<string, (...args: any[]) => any>>(
	handlers?: Handlers,
): React.MutableRefObject<Handlers | undefined> {
	const handlerRef = useRef<Handlers | undefined>(handlers);

	useLayoutEffect(() => {
		handlerRef.current = handlers;
	});

	return handlerRef;
}
